export default __webpack_public_path__ + "static/media/wood-chest-open-tab.0865f14d.png";